"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _json = require("refractor/lang/json.js");

var _json2 = _interopRequireDefault(_json);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
exports.default = _json2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-syntax-highlighter/languages/prism/json.js
// module id = 353
// module chunks = 0